import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-method"
// NOTE: This controller is simplified since only credit card payment method is now available.
// Cash payment option has been removed. This controller is kept for backward compatibility
// but may be removed entirely in the future since payment method toggle is no longer needed.
export default class extends Controller {
  connect() {
    // Initialize controller
    // No initialization needed since credit card is the only payment method
  }
}
